import React from "react";
import Confetti from "react-confetti";

export default function Anniversarycard({
  name,
  age,
  onClose,
  photoUrl,
  show,
}) {
  return (
    <>
      <Confetti
        width={window.innerWidth}
        height={window.innerHeight}
        numberOfPieces={500} // more confetti
        gravity={0.15} // slower fall
        wind={0.03} // slight horizontal movement
        recycle={show} // keeps going while visible
        tweenDuration={4000} // smooth animation
        friction={0.99}
      />

      <div className="birthday-overlay">
        <div className="birthday-card">
          <h1>
            {age > 0
              ? "🎊 Happy Work Anniversary 🎊"
              : "🎉 Welcome to Brain Technosys 🎉"}
          </h1>
          {photoUrl && (
            <div className="photo-wrappers">
              <img src={photoUrl} alt={name} />
            </div>
          )}
          <h2 className="birthday-name">{name}</h2>

          <p className="birthday-message">
         
            {age > 0 ? (
              <>
                Heartfelt Congratulations on your <span>{age}st</span>{" "}
                Anniversary! 🏆
              </>
            ) : (
              <>🎉 Welcome to BT! We're excited to have you onboard 🚀</>
            )}
          </p>

          <button className="birthday-button" onClick={onClose}>
            🎁 Thank You
          </button>
        </div>
      </div>
    </>
  );
}
